import React from "react";
import Toast from "@/components/Toast/Toast";

const Step1 = () => {

    return (
        <div className="relative mt-8">
            <Toast
                visible={true}
                type="info"
                message={
                    <div className="text-sm leading-relaxed">
                        <p className="mb-2">
                            Para el inicio del trámite de <strong>liquidación de traspaso de dominio</strong> (Cálculo de Alcabala y Utilidades), se requiere un <strong>certificado de avalúo vigente</strong>.
                        </p>
                        <p className="mb-2">
                            Para realizar este trámite deberá tener a la mano los siguientes documentos escaneados y en formato PDF:
                        </p>
                        <ul className="list-disc list-inside ml-4">
                            <li>Minuta</li>
                            <li>Código del certificado de solvencia de registro de la propiedad (NO CADUCADO)</li>
                            <li>Tanto vendedor como comprador NO tener deudas con el Municipio de Portoviejo y sus empresas y haber firmado el acuerdo de responsabilidad</li>
                            <li>Escritura de adquisición del predio</li>
                            <li>Copias de cédula, vendedor y comprador</li>
                        </ul>
                    </div>
                }
            />
        </div>
    );
};

export default Step1;
